// extracted by mini-css-extract-plugin
export var mobileHeader = "styles-module__mobileHeader___FCiKN";
export var img = "styles-module__img___e6YvA";
export var mobileRightSpacer = "styles-module__mobileRightSpacer___u45WT";